import { HistoryTable } from 'bank-entity-history/src/components/HistoryTable'
import { TableDataQa } from 'commons/types/enums'
import { Layer, PageSectionPrimary } from 'ui/components'

import { useHRRContext } from '../../context'

export const History = () => {
  const { data, isLoading, routeApi } = useHRRContext()
  const {
    history,
    form: { historyPage, historySize },
    historyTotalCount
  } = data
  const navigate = routeApi.useNavigate()

  return (
    <PageSectionPrimary title="History" face="outlined" anchor="history">
      <Layer rounded shadowed stretch>
        <HistoryTable
          dataQa={TableDataQa.HRR_HISTORY}
          loading={isLoading}
          items={history}
          pagination={{
            page: historyPage,
            size: historySize,
            total: historyTotalCount,
            onChange: (page, size) => {
              navigate({
                to: '.',
                search: (prev) => ({ ...prev, historyPage: page, historySize: size }),
                resetScroll: false
              })
            }
          }}
        />
      </Layer>
    </PageSectionPrimary>
  )
}
